import { render, staticRenderFns } from "./N8nPages.vue?vue&type=template&id=0b783455&"
import script from "./N8nPages.vue?vue&type=script&lang=js&"
export * from "./N8nPages.vue?vue&type=script&lang=js&"
import style0 from "./N8nPages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports